import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { setReady } from './actions';
import { selectSettingReady } from './selectors';
import ConfirmButton from '../ConfirmButton';
import { Muted } from '../Controls';
import { selectActiveGame, selectActivePokemon, selectGamePlayer } from '../ActiveGame/selectors';

const ReadyButton = ({ userId }) => {
  const dispatch = useDispatch();
  const activePokemon = useSelector((state) => selectActivePokemon(state, { userId }));
  const game = useSelector(selectActiveGame);
  const gamePlayer = useSelector((state) => selectGamePlayer(state, { userId }));
  const settingReady = useSelector(selectSettingReady);

  const playerChoosesWhoStarts = game.get('start_chooser_id') === userId;

  const showReady = game.get('initial_coin_flip') !== null && (
    (playerChoosesWhoStarts && game.get('first_player_id')) || !playerChoosesWhoStarts
  ) && activePokemon;

  if (gamePlayer.get('ready')) {
    return <Muted>Ready. Waiting for your opponent.</Muted>;
  }

  if (!showReady) {
    return null;
  }

  return (
    <ConfirmButton
      onConfirm={() => dispatch(setReady())}
      disabled={settingReady}
      prompt="Ready? Your setup is locked in once you are."
      confirmLabel="Ready"
      primary
    >
      Ready
    </ConfirmButton>
  );
};

ReadyButton.propTypes = {
  userId: PropTypes.number.isRequired,
};

export default ReadyButton;